import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import RecatchBasicForm from 'views/RecatchForm/BasicForm';

const Contact = () => {
  
  // 채널톡 오픈
  // const openChannelTalk = () =>{
  //   window.ChannelIO('showMessenger');
  // }

  // Viewer 모달 팝업
  const [viewerModal, setViewerModal] = useState(false);
  // Viewer 모달 팝업 
  const handleViewerModal = () => {
    setViewerModal(!viewerModal);
  }

  // 포트폴리오 클릭
  const openRecatchForm = (item) => {

    // 뷰어 호출
    handleViewerModal();

  }

  return (
    <Container>
      {/* <ContactContainer className='briphy-recatch-form'> */}
      <ContactContainer className='briphy-portfolio-recatch'>
        <TextWrapper>브리피와 함께 매칭 받아보세요</TextWrapper>
        <ButtonWrapper>
          {/* <Button onClick={() => openChannelTalk()}>무료 상담 받기</Button> */}
          <Button onClick={() => openRecatchForm()}>무료 상담 받기</Button>
          <Button accent={true}><Link to={'/quotation'}>무료 촬영견적 받기</Link></Button>
        </ButtonWrapper>
      </ContactContainer>
      <RecatchBasicForm 
        open={viewerModal}
        handleModal={handleViewerModal}
      />
    </Container>
  )
}

export default Contact;

const Container = styled.div`
  display: flex;
  width: 100%;  
  margin: 0 auto;
  background-color: #2C2C2C;
`

const ContactContainer = styled.form`
  width: 100%;
  padding: 152px 0;
  text-align: center;

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    margin: 0;
    padding: 60px 16px;
  }
`

const TextWrapper = styled.div`
  color: #FFFFFF;
  font-size: 40px;
  font-weight: 800;
  line-height: 48px;
  margin-bottom: 42px;

  @media ${({theme}) => theme.device.mobile} {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 56px
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  @media ${({theme}) => theme.device.mobile} {
    flex-direction: column;
  }
`

const Button = styled.div`
  width: 264px;
  height: 64px;
  color: #FFFFFF;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  padding: 20px;
  background: ${props => props.accent ? '#FE5A1D' : '#4B4B4B'};
  border-radius: 32px;
  cursor: pointer;

  & + & { 
    margin-left: 40px;
  }

  @media ${({theme}) => theme.device.mobile} {
    width: 100%;
    height: 54px;
    padding: 17px 10px 15px;
    font-size: 18px;
    line-height: 22px;

    & + & {
      margin-left: 0;
      margin-top: 10px;
    }
  }
`